import { getReportParams, report } from 'app/middleware/report';
import EpiContext from '@episerver/spa-core/Spa';

const SubAreaEnum = {
  IDFDeliveryDeviceRepair: 'IDFDeliveryDeviceRepair',
  IDFLoginPage: 'IDFLoginPage',
  IDFRegistrationYourPlan: 'IDFRegistrationYourPlan',
  IDFRegistrationPersonalInformation: 'IDFRegistrationPersonalInformation',
  IDFRegistrationDeviceSelection: 'IDFRegistrationDeviceSelection',
  IDFRegistrationSIMoreSIM: 'IDFRegistrationSIMoreSIM',
  IDFRegistrationOrderConfirmation: 'IDFRegistrationOrderConfirmation',
  IDFRegistrationOrderSummary: 'IDFRegistrationOrderSummary',
  IDFRegistrationGeneralError: 'IDFRegistrationGeneralError',
  IDFDeviceSelection: 'IDFDeviceSelection',
  IDFCoordinatingSupply: 'IDFCoordinatingSupply',
  IDFOrderSummary: 'IDFOrderSummary',
  IDFGeneralError: 'IDFGeneralError',
  IDFFamilyMember: 'IDFFamilyMember',
};

// Enums for ActionType
const ActionTypeEnum = {
  DeliveryAddressAndDatePage: 'Delivery address and date page',
  LoginPageIDF: 'Login page IDF',
  ChoosePackage: 'Choose Package',
  PersonalInformation: 'Personal Information',
  DeviceSelection: 'Device Selection',
  DeviceSelectionDevicePage: 'Device Selection Device Page',
  SIMSelection: 'SIM Selection',
  eSIMSelection: 'eSIM Selection',
  OrderConfirmation: 'Order Confirmation',
  OrderSummary: 'Order Summary',
  GeneralError: 'General Error',
  CoordinatingSupplyShipping: 'Coordinating Supply Shipping',
  CoordinatingSupplyPickup: 'Coordinating Supply Pickup',
  SelectionLine: 'Selection Line',
  SelectionBan: 'Selection Ban',
};

// Enum for Status
const StatusEnum = {
  Error: 'Error',
  Completed: 'Completed',
  Ongoing: 'Ongoing',
};

export const dwhDictionary = {
  IDFDeliveryDeviceRepair_Error: {
    SubArea: SubAreaEnum.IDFDeliveryDeviceRepair,
    ActionType: ActionTypeEnum.DeliveryAddressAndDatePage,
    Status: StatusEnum.Error,
    MessageText: 'General Error',
  },

  IDFDeliveryDeviceRepair_Completed: {
    SubArea: SubAreaEnum.IDFDeliveryDeviceRepair,
    ActionType: ActionTypeEnum.DeliveryAddressAndDatePage,
    Status: StatusEnum.Completed,
    MessageText: 'Success',
  },

  SelectedJoinBanner: {
    SubArea: SubAreaEnum.IDFRegistrationYourPlan,
    ActionType: ActionTypeEnum.ChoosePackage,
    Status: StatusEnum.Ongoing,
    MessageText: 'Selected Join Banner',
  },

  SelectedPackage: {
    SubArea: SubAreaEnum.IDFRegistrationYourPlan,
    ActionType: ActionTypeEnum.ChoosePackage,
    Status: StatusEnum.Ongoing,
    MessageText: 'Selected package',
  },

  SelectedPackage_ContinueClicked: {
    SubArea: SubAreaEnum.IDFRegistrationYourPlan,
    ActionType: ActionTypeEnum.ChoosePackage,
    Status: StatusEnum.Ongoing,
    MessageText: 'continue button clicked',
  },
  SelectedPackage_Error: {
    SubArea: SubAreaEnum.IDFRegistrationYourPlan,
    ActionType: ActionTypeEnum.ChoosePackage,
    Status: StatusEnum.Error,
    MessageText: 'General Error',
  },
  PersonalInformation_Ongoing: {
    SubArea: SubAreaEnum.IDFRegistrationPersonalInformation,
    ActionType: ActionTypeEnum.PersonalInformation,
    Status: StatusEnum.Ongoing,
    MessageText: 'Approval information security form',
  },
  ProcessSelection_Ongoing: {
    SubArea: SubAreaEnum.IDFRegistrationDeviceSelection,
    ActionType: ActionTypeEnum.DeviceSelection,
    Status: StatusEnum.Ongoing,
    MessageText: 'IDF Registration Device Selection device purchase or without',
  },
  DeviceSelection_Completed: {
    SubArea: SubAreaEnum.IDFRegistrationDeviceSelection,
    ActionType: ActionTypeEnum.DeviceSelectionDevicePage,
    Status: StatusEnum.Completed,
    MessageText: 'Device Page Continue button clicked',
  },

  EsimPopupDisplayed: {
    SubArea: SubAreaEnum.IDFRegistrationSIMoreSIM,
    ActionType: ActionTypeEnum.eSIMSelection,
    Status: StatusEnum.Ongoing,
    MessageText: 'POPUP eSIM Displayed',
  },
  EsimPopupButtonClicked: {
    SubArea: SubAreaEnum.IDFRegistrationSIMoreSIM,
    ActionType: ActionTypeEnum.eSIMSelection,
    Status: StatusEnum.Completed,
    MessageText: 'POPUP eSIM button clicked',
  },
  OrderConfirmation_Completed: {
    SubArea: SubAreaEnum.IDFRegistrationOrderConfirmation,
    ActionType: ActionTypeEnum.OrderConfirmation,
    Status: StatusEnum.Completed,
    MessageText: 'Order Confirmation Page button clicked',
  },
  OrderSummary_Completed: {
    SubArea: SubAreaEnum.IDFRegistrationOrderSummary,
    ActionType: ActionTypeEnum.OrderSummary,
    Status: StatusEnum.Completed,
    MessageText: 'Order summary button clicked',
  },
  IDFCoordinatingSupply_Pickup_Completed: {
    SubArea: SubAreaEnum.IDFCoordinatingSupply,
    ActionType: ActionTypeEnum.CoordinatingSupplyPickup,
    Status: StatusEnum.Completed,
    MessageText: 'Coordinating Supply Pickup button clicked',
  },
  IDFCoordinatingSupply_Pickup_Completed: {
    SubArea: SubAreaEnum.IDFCoordinatingSupply,
    ActionType: ActionTypeEnum.CoordinatingSupplyShipping,
    Status: StatusEnum.Completed,
    MessageText: 'Coordinating Supply Shipping button clicked',
  },
  IDFOrderSummary_Completed: {
    SubArea: SubAreaEnum.IDFOrderSummary,
    ActionType: ActionTypeEnum.Ordersummary,
    Status: StatusEnum.Completed,
    MessageText: 'Order summary button clicked',
  },
  IDFGeneralError: {
    SubArea: SubAreaEnum.IDFRegistrationGeneralError,
    ActionType: ActionTypeEnum.GeneralError,
    Status: StatusEnum.Error,
    MessageText: 'General Error',
  },
  IDFFamilyMember_SelectionLine_Ongoing: {
    SubArea: SubAreaEnum.IDFFamilyMember,
    ActionType: ActionTypeEnum.SelectionLine,
    Status: StatusEnum.Ongoing,
    MessageText: 'Selection Line Button clicked',
  },
  IDFFamilyMember_SelectionLine_Completed: {
    SubArea: SubAreaEnum.IDFFamilyMember,
    ActionType: ActionTypeEnum.SelectionLine,
    Status: StatusEnum.Completed,
    MessageText: 'Success',
  },
  IDFFamilyMember_SelectionBan_Ongoing: {
    SubArea: SubAreaEnum.IDFFamilyMember,
    ActionType: ActionTypeEnum.SelectionBan,
    Status: StatusEnum.Ongoing,
    MessageText: 'Selection Ban Button Clicked',
  },
  IDFFamilyMember_GeneralError_Error: {
    SubArea: SubAreaEnum.IDFFamilyMember,
    ActionType: ActionTypeEnum.GeneralError,
    Status: StatusEnum.Error,
    MessageText: 'General Error',
  },
  IDFFamilyMember_GeneralError_Error_NoMoreBenefits: {
    SubArea: SubAreaEnum.IDFFamilyMember,
    ActionType: ActionTypeEnum.GeneralError,
    Status: StatusEnum.Error,
    MessageText: 'No More Family Member Benefit',
  },
  IDFFamilyMember_GeneralError_Error_NotYourLineDifferentOrg: {
    SubArea: SubAreaEnum.IDFFamilyMember,
    ActionType: ActionTypeEnum.GeneralError,
    Status: StatusEnum.Error,
    MessageText: 'Not your line, Belong to different organization',
  },
  IDFFamilyMember_GeneralError_Error_NotYourLine: {
    SubArea: SubAreaEnum.IDFFamilyMember,
    ActionType: ActionTypeEnum.GeneralError,
    Status: StatusEnum.Error,
    MessageText: 'Not your line',
  },
};

export function dwhReport(dwhObj) {
  const userDetails = EpiContext.getStore().getState().idfSale.userDetails;

  let reportParams = getReportParams();
  reportParams.area = 'IDF';
  reportParams.channel = 'WebsiteIDF';
  reportParams.subArea = dwhObj.SubArea;
  reportParams.actionType = dwhObj.ActionType;
  reportParams.subscriber = userDetails.otp_phone;
  reportParams.customerName = userDetails.first_name + ' ' + userDetails.last_name;
  reportParams.idNumber = userDetails.idfid_number;
  reportParams.status = dwhObj.Status;
  reportParams.messageText = dwhObj.MessageText;
  reportParams.param1 = dwhObj.param1 ?? '';
  reportParams.param2 = dwhObj.param2 ?? '';
  reportParams.param3 = dwhObj.param3 ?? '';
  reportParams.param4 = dwhObj.param4 ?? '';
  reportParams.param5 = dwhObj.param5 ?? '';
  reportParams.param6 = dwhObj.param6 ?? '';
  reportParams.param7 = dwhObj.param7 ?? '';
  reportParams.param8 = dwhObj.param8 ?? '';
  reportParams.param9 = dwhObj.param9 ?? '';
  reportParams.param10 = dwhObj.param10 ?? '';
  report(reportParams);
}
